/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Popover from "vux/src/components/popover/index.vue";
export default {
  name: 'Tags',
  components: {
    Popover: Popover
  },
  props: {
    showRemove: {
      type: Boolean,
      default: false
    },
    lrmargin: {
      type: String,
      default: '0.76'
    },
    tbmargin: {
      type: String,
      default: '0.72'
    },
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    defaultColor: {
      type: String,
      default: '#3ccba6'
    }
  },
  computed: {},
  methods: {
    style: function style(item) {
      var defaultColor = this.defaultColor;
      var hexToRgba = this.hexToRgba;
      var lrmargin = this.lrmargin;
      var tbmargin = this.tbmargin;
      return {
        color: item.bg_rgb ? '#FFF' : item.color_rgb || defaultColor,
        background: item.bg_rgb ? item.bg_rgb : 'transparent',
        border: "1px solid ".concat(hexToRgba(item.color_rgb || defaultColor, 0.15)),
        'box-shadow': "1px 1px 2px ".concat(hexToRgba(item.color_rgb || defaultColor, 0.15)),
        margin: "0 ".concat(lrmargin, "rem ").concat(tbmargin, "rem 0")
      };
    },
    // 将16进制转为rgba
    hexToRgba: function hexToRgba(hex, opacity) {
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;

      if (hex && reg.test(hex)) {
        // 若为#FFF之类的4位色值 先转换成6位色值
        if (hex.length === 4) {
          var hexNew = '#';

          for (var i = 1; i < 4; i++) {
            hexNew += hex.slice(i, i + 1).concat(hex.slice(i, i + 1));
          }

          hex = hexNew;
        } // 处理6位色值 生成rgba


        var rgba = [];

        for (var _i = 1; _i < 7; _i += 2) {
          rgba.push(parseInt('0x' + hex.slice(_i, _i + 2)));
        }

        return "rgba(".concat(rgba.join(','), ", ").concat(opacity, ")");
      }
    },
    removeTag: function removeTag(tagid, index) {
      this.$emit('remove', tagid, index);
    }
  }
};